import { Component, OnInit, Output, EventEmitter } from '@angular/core';
declare var jQuery: any;
import '../../../../assets/semantic/semantic.min.js';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ContactService } from '../../../_services/contact.service';


@Component({
  selector: 'app-delete-contact',
  templateUrl: './delete-contact.component.html',
  styleUrls: ['./delete-contact.component.css']
})
export class DeleteContactComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();

  private to_delete;

  constructor(private service: ContactService) { }

  ngOnInit() {
  }

  openModal(contact_id){
    this.to_delete = contact_id;
    jQuery('#delete-contact-modal').modal({closable: false}).modal('show');
  }

  deleteContact(){
    if(!this.to_delete) { // Return false if the ID of the contact is not stored
      jQuery('#delete-contact-modal').modal('hide');
      return false;
    } 
    let contact_id = this.to_delete // Store it in a var
    this.to_delete = undefined; // Invalidate the contact to delete (avoid spamming during the deletion process)
    jQuery('#delete-contact-modal').modal({closable: false}); // Set the modal unclosable during the deletion process
    this.service.deleteContact(contact_id) // Delete the Contact
      .subscribe(response => {
        jQuery('#delete-contact-modal').modal('hide');
        this.refresh.emit(true); // Close the modal
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/contact/delete-contact/delete-contact.component.ts